import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, of} from 'rxjs';
import { catchError } from 'rxjs/operators';
import {DataService} from '../data.service';
import {LoggerService} from '../../shared/common-components/logger.service';
import {StateCountry} from 'src/app/shared/common-components/common-structure';

@Injectable({
  providedIn: 'root'
})
export class StateCountryService extends DataService {

  private baseURI = this.apiUri + '/statecountry/';
  private baseURIPublic = this.apiUri + '/public/statecountry/';

  constructor(http: HttpClient, logger: LoggerService) {
    super(http);
  }

  getAll(): Observable<StateCountry[]> {
    // this.setUri('public' + this.baseURI);
    this.setUri(this.baseURI);
    return this.get().pipe(catchError(this.handleError));
  }

  getAllStates(): Observable<StateCountry[]> {
    this.setUri(this.baseURI + 'State/statecountrytype');
    return this.get().pipe(catchError(this.handleError));
  }

  getAllCountries(): Observable<StateCountry[]> {
    this.setUri(this.baseURI + 'Country/statecountrytype');
    return this.get().pipe(catchError(this.handleError));
  }

  getDomesticCountries(): Observable<StateCountry[]> {
    this.setUri(this.baseURI + 'USCanadaCountry/statecountrytype');
    return this.get().pipe(catchError(this.handleError));
  }

  getAllZones(): Observable<StateCountry[]> {
    this.setUri(this.baseURI + 'Zone/statecountrytype');
    return this.get().pipe(catchError(this.handleError));
  }

  getStateCountryByStateCountryId(stateCountryId: number): Observable<StateCountry[]> {
    this.setUri(this.baseURI + stateCountryId + 'statecountryid');
    return this.get().pipe(catchError(this.handleError));
  }

  // Get the provinces / states by parentCountryId, for Canada parentCountryId is 365
  getStateCountryByParentCountryId(parentCountryId: number): Observable<StateCountry[]> {
    this.setUri(this.baseURI + parentCountryId + '/parentCountryId');
    return this.get().pipe(catchError(this.handleError));
  }

  getStateCountryByStateCountryCode(stateCountryCode: string): Observable<StateCountry[]> {
    this.setUri(this.baseURIPublic + stateCountryCode + '/stateCountryCode');
    return this.get().pipe(catchError(this.handleError));
  }

  getAllConcorStates(): Observable<StateCountry[]> {
    this.setUri(this.baseURI + 'ConcurStates/statecountrytype');
    return this.get().pipe(catchError(this.handleError));
  }

  getAllServiceArea(): Observable<StateCountry[]> {
    this.setUri(this.baseURI + 'ServiceArea/statecountrytype');
    return this.get().pipe(catchError(this.handleError));
  }

  getUSAndCanadaStates(): Observable<StateCountry[]> {
    this.setUri(this.baseURI + 'USCanadaStates/statecountrytype');
    return this.get().pipe(catchError(this.handleError));
  }

  getCanadaStates(): Observable<StateCountry[]> {
    this.setUri(this.baseURI + 'CanadaStates/statecountrytype');
    return this.get().pipe(catchError(this.handleError));
  }

  getPublicAllCountries(): Observable<StateCountry[]> {
    this.setUri(this.baseURIPublic + 'Country/statecountrytype');
    return this.get().pipe(catchError(this.handleError));
  }

  getPublicStateCountryByParentCountryId(parentCountryId: number): Observable<StateCountry[]> {
    this.setUri(this.baseURIPublic + parentCountryId + '/parentCountryId');
    return this.get().pipe(catchError(this.handleError));
  }

}
